<div class="login-page">
  <div class="hero-panel" aria-hidden="true">
    <div class="hero-copy">
      <p class="eyebrow">{{ 'login.eyebrow' | t }}</p>
      <h1>{{ appName }}</h1>
      <p>{{ 'passwordReset.resetHero' | t }}</p>
    </div>
  </div>

  <div class="form-panel">
    <div class="lang-top">
      <app-language-switcher />
    </div>

    <form class="login-card ct-card" [formGroup]="form" (ngSubmit)="submit()">
      <div class="logo">
        <img [src]="logoUrl" [alt]="appName" />
        <div>
          <strong>{{ appName }}</strong>
          <small>{{ 'passwordReset.resetTitle' | t }}</small>
        </div>
      </div>

      @if (tokenMissing()) {
        <p class="error">{{ 'passwordReset.invalidLink' | t }}</p>
        <a class="back-link" routerLink="/forgot-password">{{ 'passwordReset.requestNewLink' | t }}</a>
      } @else if (done()) {
        <p class="success">{{ 'passwordReset.done' | t }}</p>
        <button class="ct-btn ct-btn-navy login-btn" type="button" (click)="goToLogin()">
          {{ 'passwordReset.backToLogin' | t }}
        </button>
      } @else {
        <div class="ct-field">
          <label for="password">{{ 'passwordReset.newPassword' | t }}</label>
          <input
            id="password"
            class="ct-input"
            type="password"
            formControlName="password"
            autocomplete="new-password"
          />
          @if (form.controls.password.touched && form.controls.password.hasError('required')) {
            <small class="field-error">{{ 'passwordReset.passwordRequired' | t }}</small>
          }
          @if (form.controls.password.touched && form.controls.password.hasError('minlength')) {
            <small class="field-error">{{ 'passwordReset.passwordMin' | t }}</small>
          }
        </div>

        <div class="ct-field">
          <label for="confirmPassword">{{ 'passwordReset.confirmPassword' | t }}</label>
          <input
            id="confirmPassword"
            class="ct-input"
            type="password"
            formControlName="confirmPassword"
            autocomplete="new-password"
          />
          @if (form.controls.confirmPassword.touched && form.controls.confirmPassword.hasError('required')) {
            <small class="field-error">{{ 'passwordReset.confirmRequired' | t }}</small>
          }
        </div>

        <button class="ct-btn ct-btn-navy login-btn" type="submit" [disabled]="submitting()">
          {{ 'passwordReset.savePassword' | t }}
        </button>

        @if (error()) {
          <p class="error">{{ error()! | t }}</p>
        }
      }
    </form>
  </div>
</div>
